import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import ja from 'date-fns/locale/ja'
import 'react-datepicker/dist/react-datepicker.css'
import { TextField } from '@mui/material'

registerLocale('ja', ja)

// react-datepicker の customInput は forwardRef が必須（ref を DOM input に渡す）
const RangeInput = forwardRef(function RangeInput({ value, onClick, onChange, label, placeholder }, ref) {
  return (
    <TextField
      fullWidth
      size="small"
      label={label}
      placeholder={placeholder}
      value={value}
      onClick={onClick}
      onChange={onChange}
      inputRef={ref}
      InputProps={{ readOnly: true }}
      sx={{ minWidth: 240 }}
    />
  )
})

RangeInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
}

/**
 * 期間レンジ選択（開始日〜終了日を1つのカレンダーで選ぶ、日本語表記）。
 *
 * 検索を暴発させないため、onChange は「開始のみ選択中」も呼ぶが、
 * 呼び出し側は end が揃ってから検索する運用にする（このコンポーネントは値の保持のみ）。
 */
export const DateRangeField = (props) => {
  const { start, end, onChange, label = '期間', maxDate } = props

  return (
    <DatePicker
      selectsRange
      startDate={start}
      endDate={end}
      onChange={([nextStart, nextEnd]) => onChange(nextStart, nextEnd)}
      locale="ja"
      dateFormat="yyyy/MM/dd"
      maxDate={maxDate}
      isClearable
      monthsShown={2}
      showYearDropdown
      dropdownMode="select"
      customInput={<RangeInput label={label} placeholder="期間を選択" />}
      // 期間の全体像が見えるよう、選択済みなら開始月を基準に表示
      openToDate={start ?? undefined}
      // Card 等の overflow:hidden に切り取られないよう固定配置にし、画面端では自動反転させる
      popperProps={{ strategy: 'fixed' }}
      popperPlacement="bottom-start"
    />
  )
}

DateRangeField.propTypes = {
  end: PropTypes.instanceOf(Date),
  label: PropTypes.string,
  maxDate: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  start: PropTypes.instanceOf(Date),
}
